export const VUEX_ASSORTMENT_PRODUCTS_UPDATE_FROM_GROUPSORT = 'VUEX_ASSORTMENT_PRODUCTS_UPDATE_FROM_GROUPSORT'
export const VUEX_ASSORTMENT_PRODUCTS_UPDATE_FROM_GROUPSORT_REQUEST = 'VUEX_ASSORTMENT_PRODUCTS_UPDATE_FROM_GROUPSORT_REQUEST'
export const VUEX_ASSORTMENT_PRODUCTS_UPDATE_FROM_GROUPSORT_CLEAR = 'VUEX_ASSORTMENT_PRODUCTS_UPDATE_FROM_GROUPSORT_CLEAR'

export const VUEX_ASSORTMENT_PRODUCTS_UPDATE_STYLE_SORT = 'VUEX_ASSORTMENT_PRODUCTS_UPDATE_STYLE_SORT'
